import { defineMessages } from 'react-intl';
export default defineMessages({
  MineCouponListApplicationkeySupport: {
    id: 'MineCouponListApplication.keySupport',
    defaultMessage: '客如云提供技术支持',
  },
  OrderInlineApplicationlineupInfo: {
    id: 'OrderInlineApplication.lineupInfo',
    defaultMessage: '排队信息',
  },
  OrderInlineApplicationNumberOfPeople: {
    id: 'OrderInlineApplication.NumberOfPeople',
    defaultMessage: '就餐人数',
  },
  OrderInlineApplicationgetIDNow: {
    id: 'OrderInlineApplication.getIDNow',
    defaultMessage: '立即取号',
  },
  OrderInlineApplicationUnOpen: {
    id: 'OrderInlineApplication.UnOpen',
    defaultMessage: '诶呀，没有开门',
  },
  OrderInlineApplicationdeviceNetBroken: {
    id: 'OrderInlineApplication.deviceNetBroken',
    defaultMessage: '商家设备未联网',
  },
  OrderInlineApplicationnuConnect: {
    id: 'OrderInlineApplication.nuConnect',
    defaultMessage: '设备未接入网络',
  },
  OrderInlineApplicationqueueName: {
    id: 'OrderInlineApplication.queueName',
    defaultMessage: '队列名称',
  },
  OrderInlineApplicationnumberOfWaitingTables: {
    id: 'OrderInlineApplication.numberOfWaitingTables',
    defaultMessage: '等待桌数',
  },
  OrderListApplicationshowEarlierOrder: {
    id: 'OrderListApplication.showEarlierOrder',
    defaultMessage: '查看更早的订单',
  },
  OrderListApplicationNoOrderInOneWeek: {
    id: 'OrderListApplication.NoOrderInOneWeek',
    defaultMessage: '最近一周内没有相关订单',
  },
  OrderListApplicationMakeOutBill: {
    id: 'OrderListApplication.MakeOutBill',
    defaultMessage: '开发票',
  },
  OrderListApplicationchooseOrderToMakeoutBill: {
    id: 'OrderListApplication.chooseOrderToMakeoutBill',
    defaultMessage: '请选择需要开发票的订单',
  },
  OrderListApplicationBindPNToCheckOrder: {
    id: 'OrderListApplication.BindPNToCheckOrder',
    defaultMessage: '绑定手机号，查看所有渠道订单',
  },
  OrderListApplicationGotoBind: {
    id: 'OrderListApplication.GotoBind',
    defaultMessage: '去绑定',
  },
  OrderListApplicationNoRelatedOrder: {
    id: 'OrderListApplication.NoRelatedOrder',
    defaultMessage: '没有相关订单',
  },
  OrderListApplicationWaitForMaingBill: {
    id: 'OrderListApplication.WaitForMaingBill',
    defaultMessage: '别着急，正在开票中',
  },
  OrderListApplicationSelectOrderToMakeBill: {
    id: 'OrderListApplication.SelectOrderToMakeBill',
    defaultMessage: '请选择开票订单',
  },
  OrderListApplicationShowLaterOrder: {
    id: 'OrderListApplication.ShowLaterOrder',
    defaultMessage: '查看更早的订单',
  },
  OrderListApplicationCancel: {
    id: 'OrderListApplication.Cancel',
    defaultMessage: '取消',
  },
  OrderListApplicationTS: {
    id: 'OrderListApplication.TS',
    defaultMessage: '堂食',
  },
  OrderListApplicationWM: {
    id: 'OrderListApplication.WM',
    defaultMessage: '外卖',
  },
  OrderListApplicationYD: {
    id: 'OrderListApplication.YD',
    defaultMessage: '预定',
  },
  OrderListApplicationPD: {
    id: 'OrderListApplication.PD',
    defaultMessage: '排队',
  },
  OrderListApplicationHB: {
    id: 'OrderListApplication.HB',
    defaultMessage: '烘焙',
  },
  PayDetailApplicationorderAutoCanceled: {
    id: 'PayDetailApplication.orderAutoCanceled',
    defaultMessage: '订单已经自动取消... 即将自动跳转',
  },
  PayDetailApplicationnoNeedPaidOrder: {
    id: 'PayDetailApplication.noNeedPaidOrder',
    defaultMessage: '没有金额需要支付',
  },
  PayDetailApplicationPaid: {
    id: 'PayDetailApplication.Paid',
    defaultMessage: '已支付：',
  },
  PayDetailApplicationBalance: {
    id: 'PayDetailApplication.Balance',
    defaultMessage: '余额',
  },
  PayDetailApplicationWX: {
    id: 'PayDetailApplication.WX',
    defaultMessage: '微信',
  },
  PayDetailApplicationAlipay: {
    id: 'PayDetailApplication.Alipay',
    defaultMessage: '支付宝',
  },
  PayDetailApplicationotherWays: {
    id: 'PayDetailApplication.otherWays',
    defaultMessage: '其他方式',
  },
  PayDetailApplicationcannotRechargePrompt: {
    id: 'PayDetailApplication.cannotRechargePrompt',
    defaultMessage: '您不是会员，无法充值，绑定手机号即可成为会员',
  },
  PayDetailApplicationRegisterToPay: {
    id: 'PayDetailApplication.RegisterToPay',
    defaultMessage: '您不是会员，注册即可储值支付',
  },
  PayDetailApplicationbindPNToPay: {
    id: 'PayDetailApplication.bindPNToPay',
    defaultMessage: '绑定手机号即可储值支付',
  },
  PayDetailApplicationRechargeSuccessInfo: {
    id: 'PayDetailApplication.RechargeSuccessInfo',
    defaultMessage: '成功储值并支付该订单，当前储值余额',
  },
  PayDetailApplicationJumping: {
    id: 'PayDetailApplication.Jumping',
    defaultMessage: '1.5秒后跳转到订单详情页',
  },
  PayDetailApplicationadvancedDeduction: {
    id: 'PayDetailApplication.advancedDeduction',
    defaultMessage: '预付金已抵扣：',
  },
  PayDetailApplicationorderValue: {
    id: 'PayDetailApplication.orderValue',
    defaultMessage: '订单金额：',
  },
  PayDetailApplicationMyBalance: {
    id: 'PayDetailApplication.MyBalance',
    defaultMessage: '我的余额：',
  },
  PayDetailApplicationgetRandomDiscount: {
    id: 'PayDetailApplication.getRandomDiscount',
    defaultMessage: '客官，恭喜获得随机减免机会！',
  },
  PayDetailApplicationshareToDiscount: {
    id: 'PayDetailApplication.shareToDiscount',
    defaultMessage: '分享即可减免',
  },
  PayDetailApplicationgetDiscount: {
    id: 'PayDetailApplication.getDiscount',
    defaultMessage: '恭喜获得{amount}减免金',
  },
  PayDetailApplicationfillToUseDiscount: {
    id: 'PayDetailApplication.fillToUseDiscount',
    defaultMessage: '满{amount}可用，仅对当前订单生效',
  },
  PayDetailApplicationbalanceInsufficient: {
    id: 'PayDetailApplication.balanceInsufficient',
    defaultMessage: '余额不足，请先储值再支付',
  },
  PayDetailApplicationRechargedBalance: {
    id: 'PayDetailApplication.RechargedBalance',
    defaultMessage: '储值后的余额为{amount}',
  },
  PayDetailApplicationpayWithProblem: {
    id: 'PayDetailApplication.payWithProblem',
    defaultMessage: '支付有问题？',
  },
  PayDetailApplicationconnectShopToRefund: {
    id: 'PayDetailApplication.connectShopToRefund',
    defaultMessage: '若需要退款，请先完成第三方支付后联系商家处理',
  },
  PayDetailApplicationlastPayTime: {
    id: 'PayDetailApplication.lastPayTime',
    defaultMessage: '支付剩余时间',
  },
  PayDetailApplicationwaitForPaying: {
    id: 'PayDetailApplication.waitForPaying',
    defaultMessage: '待支付金额',
  },
  PayDetailApplicationpaidBalance: {
    id: 'PayDetailApplication.paidBalance',
    defaultMessage: '余额已支付',
  },
  PayDetailApplicationuseThirdPartToPay: {
    id: 'PayDetailApplication.useThirdPartToPay',
    defaultMessage: '请用第三方支付剩余',
  },
  PayDetailApplicationcontinuePay: {
    id: 'PayDetailApplication.continuePay',
    defaultMessage: '{second}s 后继续支付',
  },
  PayDetailBrandApplicationVipBalancePay: {
    id: 'PayDetailBrandApplication.VipBalancePay',
    defaultMessage: '会员余额支付',
  },
  PaySuccessRetailtips: {
    id: 'PaySuccessRetail.tips',
    defaultMessage: '支付成功',
  },
  PaySuccessRetailbackToIndex: {
    id: 'PaySuccessRetail.backToIndex',
    defaultMessage: '返回首页',
  },
  PaySuccessRetailorderDetail: {
    id: 'PaySuccessRetail.orderDetail',
    defaultMessage: '订单详情',
  },
  CombinedPaymentbanlancePay: {
    id: 'CombinedPayment.banlancePay',
    defaultMessage: '余额支付',
  },
  PayDetailBrandApplicationVipBalance: {
    id: 'PayDetailBrandApplication.VipBalance',
    defaultMessage: '会员余额',
  },
  PayDetailBrandApplicationWxPayPrompt: {
    id: 'CombinedPayment.WXPayPrompt',
    defaultMessage: '微信客户端版本5.0以上',
  },
  PayDetailBrandApplicationMPayPrompt: {
    id: 'CombinedPayment.MPayPrompt',
    defaultMessage: '推薦 MPay 用戶使用',
  },
  CombinedPayment: {
    id: 'CombinedPayment.CombinedPayment',
    defaultMessage: '组合支付',
  },
  noOrderInHalfYear: {
    id: 'noOrderInHalfYear',
    defaultMessage: '最近半年内没有相关订单',
  },
  payDetailSelectStoreToPay: {
    id: 'payDetailSelectStoreToPay',
    defaultMessage: '请选择需要储值并支付的金额',
  },
  payDetailStoreSuccess: {
    id: 'payDetailStoreSuccess',
    defaultMessage: '成功储值并支付该订单，当前储值余额',
  },
  payDetailJumpTo: {
    id: 'payDetailJumpTo',
    defaultMessage: ', 1.5秒后跳转到订单详情页',
  },
  payDetailShare: {
    id: 'payDetailShare',
    defaultMessage: '分享即可减免',
  },
  payDetailCongratulate: {
    id: 'payDetailCongratulate',
    defaultMessage: '恭喜获得',
  },
  payDetailDiscountMoney: {
    id: 'payDetailDiscountMoney',
    defaultMessage: '减免金',
  },
  payDetailFillToUse: {
    id: 'payDetailFillToUse',
    defaultMessage: '满{currency}可用，仅对当前订单生效',
  },
  payDetailRecommend: {
    id: 'payDetailRecommend',
    defaultMessage: '荐',
  },
  payDetailStoreAndPay: {
    id: 'payDetailStoreAndPay',
    defaultMessage: '储值并支付',
  },
  payDetailShare2: {
    id: 'payDetailShare2',
    defaultMessage: '分享',
  },
  payDetailGiveUp: {
    id: 'payDetailGiveUp',
    defaultMessage: '放弃',
  },
  payDetailIamInbrand: {
    id: 'payDetailIamInbrand',
    defaultMessage: '我正在{brandName}品牌（{shopName}分店名）就餐',
  },
  payDetailComeToVisite: {
    id: 'payDetailComeToVisite',
    defaultMessage: '听说他们家的食物不仅美味，还有大量优惠，赶紧来围观',
  },
  payDetailStoreAndToPay: {
    id: 'payDetailStoreAndToPay',
    defaultMessage: '储值{currency}{storeandpayValue}并结账',
  },
  payDetailStoredBalance: {
    id: 'payDetailStoredBalance',
    defaultMessage: '储值后的余额为',
  },
  payDetailInputSeatVipPW: {
    id: 'payDetailInputSeatVipPW',
    defaultMessage: '请输入雅座会员密码',
  },
  payDetailGoOnPay: {
    id: 'payDetailGoOnPay',
    defaultMessage: '{countTime}s后继续支付',
  },
  payDetailRecommendTip: {
    id: 'payDetailRecommendTip',
    defaultMessage: '荐',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/container/part5/index.js